import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { CityImprovementTypes } from '@colonist/game-states';
import { EnumUtils } from '@colonist/utils';
import { AudioManager, AudioType } from '@colonist/audio';
import { LEVEL_REQUIRED_TO_UNLOCK_SPECIAL_ABILITY, MINIMUM_LEVEL_REQUIRED_FOR_METROPOLIS } from '@colonist/game-state-types';
export class UIGameCityImprovementAchievementController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.CityImprovementStateUpdated:
                this.checkIfPlayerUnlockedSpecialAbility();
                break;
            default:
                break;
        }
    }
    initMyOldCityImprovementLevels() {
        var _this_myCityImprovementsState_CityImprovementTypes_Politics, _this_myCityImprovementsState_CityImprovementTypes_Science, _this_myCityImprovementsState_CityImprovementTypes_Trade;
        var _this_myCityImprovementsState_CityImprovementTypes_Politics_level, _this_myCityImprovementsState_CityImprovementTypes_Science_level, _this_myCityImprovementsState_CityImprovementTypes_Trade_level;
        this.myOldCityImprovementLevels = new Map([
            [
                CityImprovementTypes.Politics,
                (_this_myCityImprovementsState_CityImprovementTypes_Politics_level = (_this_myCityImprovementsState_CityImprovementTypes_Politics = this.myCityImprovementsState[CityImprovementTypes.Politics]) === null || _this_myCityImprovementsState_CityImprovementTypes_Politics === void 0 ? void 0 : _this_myCityImprovementsState_CityImprovementTypes_Politics.level) !== null && _this_myCityImprovementsState_CityImprovementTypes_Politics_level !== void 0 ? _this_myCityImprovementsState_CityImprovementTypes_Politics_level : 0
            ],
            [
                CityImprovementTypes.Science,
                (_this_myCityImprovementsState_CityImprovementTypes_Science_level = (_this_myCityImprovementsState_CityImprovementTypes_Science = this.myCityImprovementsState[CityImprovementTypes.Science]) === null || _this_myCityImprovementsState_CityImprovementTypes_Science === void 0 ? void 0 : _this_myCityImprovementsState_CityImprovementTypes_Science.level) !== null && _this_myCityImprovementsState_CityImprovementTypes_Science_level !== void 0 ? _this_myCityImprovementsState_CityImprovementTypes_Science_level : 0
            ],
            [
                CityImprovementTypes.Trade,
                (_this_myCityImprovementsState_CityImprovementTypes_Trade_level = (_this_myCityImprovementsState_CityImprovementTypes_Trade = this.myCityImprovementsState[CityImprovementTypes.Trade]) === null || _this_myCityImprovementsState_CityImprovementTypes_Trade === void 0 ? void 0 : _this_myCityImprovementsState_CityImprovementTypes_Trade.level) !== null && _this_myCityImprovementsState_CityImprovementTypes_Trade_level !== void 0 ? _this_myCityImprovementsState_CityImprovementTypes_Trade_level : 0
            ]
        ]);
    }
    checkIfPlayerUnlockedSpecialAbility() {
        const unlockedCityImprovementType = this.didPlayerUnlockSpecialAbility();
        if (unlockedCityImprovementType == undefined) return;
        this.unlockedSpecialAbility(unlockedCityImprovementType);
    }
    didPlayerUnlockSpecialAbility() {
        let unlockedCityImprovementType;
        EnumUtils.iterateEnum(CityImprovementTypes, (type)=>{
            var _this_myCityImprovementsState_type;
            const previousLevel = this.myOldCityImprovementLevels.get(type);
            const newLevel = (_this_myCityImprovementsState_type = this.myCityImprovementsState[type]) === null || _this_myCityImprovementsState_type === void 0 ? void 0 : _this_myCityImprovementsState_type.level;
            if (newLevel == undefined || previousLevel == undefined) return;
            if (newLevel != LEVEL_REQUIRED_TO_UNLOCK_SPECIAL_ABILITY) return;
            if (previousLevel >= newLevel) return;
            this.playCityImprovementSound(newLevel);
            this.myOldCityImprovementLevels.set(type, newLevel);
            unlockedCityImprovementType = type;
        });
        return unlockedCityImprovementType;
    }
    unlockedSpecialAbility(cityImprovementType) {
        switch(cityImprovementType){
            case CityImprovementTypes.Politics:
                this.unlockedFortress();
                break;
            case CityImprovementTypes.Science:
                this.unlockedAqueduct();
                break;
            case CityImprovementTypes.Trade:
                this.unlockedTradingHouse();
                break;
        }
    }
    unlockedFortress() {
        this.broadCastPlayerReceivedAchievement('Fortress');
    }
    unlockedAqueduct() {
        this.broadCastPlayerReceivedAchievement('Aqueduct');
    }
    unlockedTradingHouse() {
        this.broadCastPlayerReceivedAchievement('TradingHouse');
    }
    // eslint-disable-next-line colonist/camelcase-union-values -- achievement type keys
    broadCastPlayerReceivedAchievement(achievementType) {
        const achievement = {
            achievementOwnerNew: this.uiGameManager.gameController.myColor,
            achievementType: achievementType
        };
        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement);
    }
    playCityImprovementSound(newCityLevel) {
        if (this.uiGameManager.gameController.isReplay) return;
        if (newCityLevel == MINIMUM_LEVEL_REQUIRED_FOR_METROPOLIS) return;
        if (newCityLevel == LEVEL_REQUIRED_TO_UNLOCK_SPECIAL_ABILITY) return AudioManager.play(AudioType.AchievementCKProgress);
        AudioManager.play(AudioType.CityImprovement);
    }
    constructor(uiGameManager, myCityImprovementsState){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.myCityImprovementsState = myCityImprovementsState;
        this.initMyOldCityImprovementLevels();
    }
}
